
import { getWeixinJsSdkSign } from '@/api/weixin'
import { isAndroid } from '@/libs/util'
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast)

let _wx = require('weixin-js-sdk')
export const wx = _wx
// 微信接口是否已回调
let isReady = false
// 待微信接口回调后执行
let afterReadyCallbacks = []
/**
 * 添加待微信回调后执行函数
 */
export const afterReady = (callback)=> {
    // 如果调用函数时微信已回调，则直接执行,否则添加到队列，等待回调后执行
    if(isReady){
        callback();
    }else{
        afterReadyCallbacks.push(callback);
    }
}
/*
 * wxConfig(['',''], ready(), err()); // 调用方法
 */
export const wxConfig = (jsApiList, ready, error) => {
    // const url = location.href.replace(window.location.hash, '');
    // 进行签名的时候  Android 不用使用之前的链接， ios 需要
    let url = location.href.split('#')[0]
    url = isAndroid ? location.href.split('#')[0] : window.entryUrl || url;

    // console.log('config:'+ url)
    getWeixinJsSdkSign(url).then(res => {
        const data = res.data;
        if (data.code == 0) {
            const params = data.params;
            _wx.config({
                debug: false,
                appId: params.appId,
                timestamp: params.timestamp,
                nonceStr: params.nonceStr,
                signature: params.signature,
                jsApiList: jsApiList
            });
        } else {
            if(process.env.NODE_ENV !== 'development'){
                // alert('加载微信配置失败：'+ data.msg)
                Toast('加载微信配置失败：'+ data.msg);
            }else{
                console.log('加载微信配置失败：'+ data.msg)
                Toast('加载微信配置失败：'+ data.msg);
            }
        }
    })

    _wx.ready(function(){
        isReady = true
        afterReadyCallbacks.forEach((callback)=>{
            callback()
        })
        if (ready && typeof ready === 'function') {
            ready();
            // if (isAndroid) {
            //     // 安卓ready立即设置分享内容会出现permission denied错误
            //     setTimeout(() => {
            //         ready();
            //     }, 500)
            // } else {
            //     ready();
            // }
        }
    });
    _wx.error(function(res){
        if(error && typeof error === 'function'){ error(res);}
    });
};
